import { render, staticRenderFns } from "./featureComponent.vue?vue&type=template&id=731e703d&scoped=true&"
import script from "./featureComponent.vue?vue&type=script&lang=js&"
export * from "./featureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e703d",
  null
  
)

export default component.exports